export default {
  /**
   * 判断浏览器是否是IE
   * @returns {boolean}
   */
  isIE(userAgent) {
    var UA = userAgent || navigator.userAgent;
    if ((/msie/i).test(UA)) {
      return UA.match(/msie (\d+\.\d+)/i)[1];
    } else if (~UA.toLowerCase().indexOf('trident') && ~UA.indexOf('rv')) {
      return UA.match(/rv:(\d+\.\d+)/)[1];
    }
    return false;
  },
  /**
   * @synopsis 判断是否为macos
   * @returns {boolean} 是否为macos
   */
  isMacOS() {
    var szPlatform = navigator.platform;
    return 'MacIntel' === szPlatform;
  },

  /**
   * 判断是否是safari浏览器
   * @returns {boolean}
   */
  isSafari() {
    var userAgent = navigator.userAgent;
    return (/Safari/).test(userAgent) && !(/Chrome/).test(userAgent);
  },
  /**
   * 获取浏览器语言的方法
   * @returns {string} 根语言，除中文外，其他语言的方言不考虑，仅采用前两位
   */
  getBrowserLanguage() {
    var language = (navigator.language || navigator.browserLanguage).toLowerCase();
    language = language.replace('-', '_');
    // var rootLanguage = language.substring(0, 2); //取前面两个
    // if ('zh' === rootLanguage) {
    //   rootLanguage = language.substring(0, 2) + '_' + language.split('_')[1].toUpperCase();
    // } else if ('pt' === rootLanguage) {
    //   rootLanguage = language;
    // }
    return language;
  },

  /**
   * 根据语言获取编码类型
   * @param lng {String} 语言
   * @returns {string} 编码格式
   */
  getEncoding(lng) {
    var encodeTable = {
      'bg': 'iso-8859-5',
      'cs': 'iso-8859-2',
      'da': 'iso-8859-1',
      'de': 'iso-8859-1',
      'es': 'iso-8859-1',
      'fr': 'iso-8859-15',
      'hu': 'iso-8859-2',
      'it': 'iso-8859-1',
      'ja': 'shift-jis',
      'nl': 'iso-8859-1',
      'pl': 'iso-8859-2',
      'pt': 'iso-8859-1',
      'ru': 'iso-8859-5',
      'th': 'iso-8859-11',
      'tr': 'iso-8859-3',
      'zh_CN': 'gb2312',
      'zh_cn': 'gb2312', //增加小写方式language获取对应编码方式
      'zh': 'gb2312',
      'zh_TW': 'big5',
      'zh_tw': 'big5',
      'ko': 'EUC-KR',
      'fi': 'iso-8859-15',
      'vi': 'Windows-1258',
      'et': 'iso-8859-4',
      'el': 'iso-8859-7',
      'sk': 'iso-8859-2',
      'ro': 'iso-8859-2',
      'sv': 'iso-8859-10',
      'nb': 'iso-8859-10',
      'hr': 'iso-8859-2',
      'sl': 'iso-8859-2',
      'sr': 'iso-8859-2',
      'lv': 'iso-8859-5',
      'lt': 'iso-8859-4',
      'pt-BR': 'iso-8859-15',
      'pt-br': 'iso-8859-15',
      'kk': '8859-5',
      'ky': '8859-5',
      'ar': 'iso-8859-6',
      'fa': 'iso-8859-6',
      'he': 'iso-8859-8',
      'uz': '8859-9'
    };
    lng = lng || this.getBrowserLanguage();
    return encodeTable[lng] || 'utf-8';
  },

  encoding() {
    return this.getEncoding(this.getBrowserLanguage());
  },
  getBrowserType() {
    let navigator = window.navigator;
    let browserType = '';

    let checkType = function (regex) {
      return regex.test(navigator.userAgent.toLowerCase());
    };

    if (checkType(/msie/)) { //ie10以下
      browserType = 'ie';
    }
    if (checkType(/rv:/)) { //ie11兼容
      browserType = 'ie';
    }
    if (checkType(/firefox/)) { //firefox
      browserType = 'firefox';
    }
    if (checkType(/chrome/)) { //chrome
      browserType = 'chrome';
    }
    if (checkType(/opera/)) { //opera
      browserType = 'opera';
    }
    if (checkType(/safari/) && (!checkType(/chrome/))) { //safari
      browserType = 'safari';
    }

    return browserType;
  },

  getBrowserLanguageType() {
    let browserLang = (
      window.navigator.browserLanguage || window.navigator.language
    )
      .toLowerCase()
      .replace('-', '_');
    let rootLang = browserLang.substring(0, 2);
    if ('zh' === rootLang && browserLang.split('_')[1]) {
      rootLang += '_' + browserLang.split('_')[1].toUpperCase();
    }
    return rootLang;
  }
};
